import { BaseQueryFn, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { manager } from '../common/auth/auth';
import { IRoleChooser } from '../common/roleChooser/roleChooserTypes';

const baseQueryWithToken: BaseQueryFn = async (args, api, extraOptions) => {
    try {
        const user = await manager.getUser();
        if (!user || !user.access_token) {
            return {
                error: {
                    status: 401,
                    statusText: 'Unauthorized',
                    data: 'Not authenticated'
                }
            };
        }
        return fetchBaseQuery({
            baseUrl: `${import.meta.env.VITE_ROLE_API}/api/`,
            prepareHeaders: headers => {
                headers.set('authorization', `Bearer ${user.access_token}`)
                return headers;
            }
        })(args, api, extraOptions);
    } catch (error) {
        return {
            error: {
                status: 401,
                statusText: 'Unauthorized',
                data: 'Authentication failed'
            }
        };
    }
}

export const roleApi = createApi({
  baseQuery: baseQueryWithToken,
  endpoints: build => ({
    getRoles: build.query<IRoleChooser, string | undefined>({
        async queryFn(municipalKey, _queryApi, _extraOptions, baseQuery) {
            try {
                if (!municipalKey) {
                    return { data: {} as IRoleChooser };
                }
                const isAuthenticated = await manager.getUser().then(user => !!user?.access_token);
                if (!isAuthenticated) {
                    return { data: {} as IRoleChooser };
                }
                const result = await baseQuery(`roles/getrolesforuser/${municipalKey}`);
                if (result.error) {
                    return { error: result.error };
                }
                return { data: result.data as IRoleChooser };
            } catch (error) {
                return { data: {} as IRoleChooser };
            }
        }
    })
  }),
  reducerPath: 'roleapi'
});

export const { useGetRolesQuery } = roleApi;